import { render, staticRenderFns } from "./MenusLanding.vue?vue&type=template&id=4d051dd2"
import script from "./MenusLanding.vue?vue&type=script&lang=js"
export * from "./MenusLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports